import { supabase } from "@/services/supabase/createClient";
import { useToast } from "@chakra-ui/react";
import * as Sentry from "@sentry/react";
import { useStripe } from "@stripe/react-stripe-js";

interface LineItem {
  price: string;
  quantity: number;
}

export const useRedirectToCheckout = () => {
  const stripe = useStripe();
  const toast = useToast();

  const redirectToCheckout = async (lineItems: LineItem[], isSubscription: boolean) => {
    try {
      const { data, error } = await supabase.functions.invoke("bff/api/payments/checkout/session", {
        method: "POST",
        body: {
          is_subscription: isSubscription,
          line_items: lineItems,
        },
      });

      if (error || !stripe || !data.session.id) {
        throw new Error("Error creating checkout session");
      }

      const { error: redirectError } = await stripe.redirectToCheckout({ sessionId: data.session.id });

      if (redirectError) {
        throw new Error("Error redirecting to checkout");
      }
    } catch (error) {
      Sentry.captureException(error);
      toast({
        title: "Error",
        position: "top",
        description: "An error occurred while redirecting to checkout",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return redirectToCheckout;
};
